export default __webpack_public_path__ + "static/media/mint-key.e830c39a.jpg";